import { LuUser } from "react-icons/lu"
import { useLocation, useNavigate } from "react-router-dom"

import IconBtn from "@fuse/sharedComponents/buttons/IconBtn"
import OutlineBtn from "@fuse/sharedComponents/buttons/OutlineBtn"
import FancyText from "@fuse/sharedComponents/typography/FancyText"
import { TWebUser } from "@letshang/constants"
import { useRecoilState } from "recoil"
import { ROUTES } from "src/App"

import { userState } from "@fuse/recoil/signup"

import { DownloadLinkMap, onOpenDownloadLink } from "@fuse/utils/DeviceDection"
import { splitFullName } from "@fuse/utils/DeviceDection"

import { Colors } from "@fuse/styles/color"

import apple from "@fuse/assets/icons/legacy/icon-apple.svg"
import googlePlay from "@fuse/assets/icons/legacy/icon-google.png"

import { logoText } from "./styles"

const DownloadButton = () => {
  const [user, setUser] = useRecoilState(userState)
  const navigate = useNavigate()
  const location = useLocation()

  const handleProfileClick = () => {
    navigate(ROUTES.PROFILE)
  }

  const handleSignupClick = () => {
    navigate(ROUTES.SIGNUP)
    setUser((prevUser: TWebUser) => ({
      ...prevUser,
      redirectUrl: location.pathname,
    }))
  }

  if (user.isLoggedIn) {
    return (
      <div
        className="flex gap-[10px] cursor-pointer"
        onClick={() => {
          handleProfileClick()
        }}
      >
        <div className="rounded-full h-[44px] w-[44px] flex items-center justify-center bg-primary">
          <LuUser className="text-[24px]" color={Colors.white} />
        </div>
        <div className="flex flex-col">
          <p className="text-left">Hey,</p>
          <p className="text-[18px] font-[600]">
            {user?.name
              ? splitFullName(user?.name)?.firstName
              : user?.firstName}
          </p>
        </div>
      </div>
    )
  } else {
    return (
      <OutlineBtn
        onClick={handleSignupClick}
        label="Signup"
        className={"px-[22px] py-[7px]"}
      />
    )
  }
}

const FancyLetsHang = () => {
  return (
    <FancyText className="text-[24px]" style={logoText}>
      Let’s Hang!
    </FancyText>
  )
}

export const LetsHangDownloadHeader = () => {
  return (
    <div className="flex flex-1 justify-between items-center mb-[73px] md:mb-[80px]">
      <FancyLetsHang />
      <DownloadButton />
    </div>
  )
}

export const IosAndroidDownloadButtons = () => {
  return (
    <div className="flex flex-row gap-5">
      <IconBtn
        icon={apple}
        title="Download on the"
        subTitle="App Store"
        onClick={() => onOpenDownloadLink(DownloadLinkMap.ios)}
      />
      <IconBtn
        icon={googlePlay}
        title="GET IN ON"
        subTitle="Google Play"
        onClick={() => onOpenDownloadLink(DownloadLinkMap.android)}
      />
    </div>
  )
}
